import { render, staticRenderFns } from "./goldPlanPayResult.vue?vue&type=template&id=7816ee9c&scoped=true"
import script from "./goldPlanPayResult.vue?vue&type=script&lang=js"
export * from "./goldPlanPayResult.vue?vue&type=script&lang=js"
import style0 from "./goldPlanPayResult.vue?vue&type=style&index=0&id=7816ee9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7816ee9c",
  null
  
)

export default component.exports